import { About, Footer, Header, Skills, Studies, Work } from './container';
import Navbar from './components/Navbar/Navbar';

import './App.scss';

function App() {
  return (
    <div className="App">
        <Navbar />
        <Header />
        <About />
        <Work />
        <Skills />
        <Studies />
        <Footer />
    </div>
  );
}

export default App;
